import { render, staticRenderFns } from "./ClientPortalUserStatus.vue?vue&type=template&id=b6a72a24&scoped=true&"
import script from "./ClientPortalUserStatus.vue?vue&type=script&setup=true&lang=js&"
export * from "./ClientPortalUserStatus.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ClientPortalUserStatus.vue?vue&type=style&index=0&id=b6a72a24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a72a24",
  null
  
)

export default component.exports